// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\EnumType.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { EnumItemMD } from '../../../../../../libs/com/MetaPattern/MDA/MD/EnumItemMD';

/**
 * 视图类型枚举 枚举类
 * 视图类型枚举，系统生成的管理页面视图的类型
 */
export enum EnumViewType {
  /** 修改 : 修改，包括新增、编辑 */
  Modify = 1,
  /** 详情 : 详情 */
  Detail = 2,
  /** 列表 : 列表 */
  List = 4,
  /** 查询 : 查询 */
  Search = 8,
  /** 自定义 : 自定义 */
  Custom = 16,
  /** 树形 : 树形 */
  Tree = 32
}

/**
 * 视图类型枚举 枚举元数据类
 * 获取枚举的元数据信息：名称、显示名称、描述、值
 */
export class EnumViewTypeMD {
  private static items = [
    new EnumItemMD('Modify', 1, '修改', '修改，包括新增、编辑'),
    new EnumItemMD('Detail', 2, '详情', '详情'),
    new EnumItemMD('List', 4, '列表', '列表'),
    new EnumItemMD('Search', 8, '查询', '查询'),
    new EnumItemMD('Custom', 16, '自定义', '自定义'),
    new EnumItemMD('Tree', 32, '树形', '树形')
  ];

  static getItem(enumItem: EnumViewType) {
    return this.items.find(item => item.name === EnumViewType[enumItem]);
  }

  static getItemByName(enumItemName: string) {
    return this.items.find(item => item.name === enumItemName);
  }

  static getItemByValue(enumItemValue: number) {
    return this.items.find(item => item.value === enumItemValue);
  }

  static getItems() {
    return this.items;
  }
}
